var map = {
	"./arrow_left.png": 41,
	"./arrow_right.png": 42,
	"./automate.png": 109,
	"./banner-backgroud.png": 110,
	"./banner-image.png": 111,
	"./chargebacks.png": 112,
	"./comingsoon.png": 113,
	"./complete_api.png": 114,
	"./every-swap.png": 115,
	"./floatingtelegram.png": 116,
	"./floatingtelegramlarge.png": 117,
	"./googlePlay-black.png": 118,
	"./googlePlay.png": 119,
	"./iPhone-black.png": 120,
	"./iPhone-white.png": 121,
	"./iPhone.png": 122,
	"./icon1.png": 123,
	"./icon2.png": 124,
	"./icon3.png": 125,
	"./icon4.png": 126,
	"./icon5.png": 127,
	"./icon6.png": 128,
	"./liquidity-pool.png": 129,
	"./liquidity_provider.png": 130,
	"./middleman.png": 131,
	"./mockup-update1.png": 132,
	"./mockup-update2.png": 133,
	"./mockup.png": 134,
	"./new_floating_tele.svg": 135,
	"./pma_token_bg.png": 136,
	"./reward_banner_bg.png": 137,
	"./reward_header_image.png": 138,
	"./security.png": 139,
	"./share.png": 140,
	"./star.png": 56,
	"./transaction.png": 141,
	"./volitality.png": 142,
	"./zeroTransaction.png": 143,
	"./zero_transaction.png": 144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;